// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "serviceSummary__included-1nbDG";
var _3 = "serviceSummary__wrapper-3roeb";
var _4 = "serviceSummary__header__number-2gtoR";
var _5 = "serviceSummary__option__price-3PtBQ";
var _6 = "serviceSummary__option__icon-2eoR7";
var _7 = "serviceSummary__option__header-1O4Bv";
export { _1 as "__esModule", _2 as "serviceSummary__included", _3 as "serviceSummary__wrapper", _4 as "serviceSummary__header__number", _5 as "serviceSummary__option__price", _6 as "serviceSummary__option__icon", _7 as "serviceSummary__option__header" }
export default { "__esModule": _1, "serviceSummary__included": _2, "serviceSummary__wrapper": _3, "serviceSummary__header__number": _4, "serviceSummary__option__price": _5, "serviceSummary__option__icon": _6, "serviceSummary__option__header": _7 }
